// src/design-system/data-table/DataTableToolbar.tsx
import type { ReactNode } from "react";

type Props = {
  search?: ReactNode;
  actions?: ReactNode;
  meta?: ReactNode;
};

export function DataTableToolbar({ search, actions, meta }: Props) {
  return (
    <div className="flex items-center justify-between gap-4">
      <div>{search}</div>
      <div className="flex items-center gap-4">
        {meta}
        {actions}
      </div>
    </div>
  );
}